module.exports = __webpack_public_path__ + "static/media/crespo4.386d6986.png";